import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import BookingButton from './BookingButton';

const {FiHeart}=FiIcons;

const ResultsSection=()=> {
const stats=[ 
{number: "85%",text: "improvement in communication milestones within 6 months"},
{number: "70%",text: "success rate in resolving feeding difficulties and expanding diet"},
{number: "90%",text: "of late talkers catch up to age-appropriate language levels"},
{number: "95%",text: "of families report reduced stress and improved daily routines"},
{number: "80%",text: "show improved executive function foundations for school readiness"},
{number: "2-3x",text: "faster rate of vocabulary growth after starting therapy"},
{number: "80%",text: "reduction in severe mealtime tantrums related to food"} 
];

const testimonials=[ 
{title: "We heard 'I love you' for the first time.",quote: "Our son was almost 3 with barely any words. After just a few months,not only is he talking,but he's telling us what he wants and how he feels. The meltdowns have dropped dramatically. We finally feel connected to him.",family: "The Khan Family"},
{title: "Mealtime is no longer a war zone.",quote: "Our daughter with a feeding tube history was terrified of food. Sanna's approach was magical. She understood the sensory fears and built her confidence bite by bite. She now eats by mouth full-time. It's a miracle.",family: "The Chen Family"},
{title: "They saw what we saw.",quote: "We knew our son was different. He didn't point,didn't wave,didn't play. While others told us to wait,Sanna got to work. She gave us the tools to connect with him. He's now a happy,engaged little boy who starts preschool next month. Early intervention is everything.",family: "The Rivera Family"} 
];

return ( 
<section id="results" className="py-20 bg-white"> 
<div className="max-w-6xl mx-auto px-6 lg:px-8"> 
<motion.div initial={{opacity: 0,y: 30}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.8}} className="text-center mb-16" > 
<h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4 font-serif"> The Early Years Numbers That <span className="text-primary-600">Change Everything</span> </h2> 
<p className="text-lg text-gray-600 max-w-2xl mx-auto"> Our Young Clients Show: </p> 
</motion.div> 

{/* Statistics Grid */} 
<div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-16"> 
{stats.map((stat,index)=> ( 
<motion.div key={index} initial={{opacity: 0,y: 30}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.8,delay: index * 0.1}} className="bg-gradient-to-br from-primary-50 to-primary-100 p-6 rounded-xl text-center border border-primary-200" > 
<div className="text-2xl lg:text-3xl font-bold text-primary-600 mb-2"> {stat.number} </div> 
<p className="text-gray-700 text-sm leading-relaxed"> {stat.text} </p> 
</motion.div> 
))} 
</div> 

{/* Testimonials */} 
<motion.div initial={{opacity: 0,y: 30}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.8}} className="mb-12" > 
<h3 className="text-2xl font-bold text-center text-gray-900 mb-8 font-serif"> Let our families speak for us: </h3> 
<div className="grid lg:grid-cols-3 gap-6"> 
{testimonials.map((testimonial,index)=> ( 
<motion.div key={index} initial={{opacity: 0,y: 30}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.8,delay: index * 0.2}} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300" > 
<div className="flex items-center mb-3"> 
<SafeIcon icon={FiHeart} className="h-5 w-5 text-accent-magenta mr-2" /> 
<h4 className="text-lg font-bold text-gray-900 font-serif"> {testimonial.title} </h4> 
</div> 
<blockquote className="text-gray-700 mb-3 italic leading-relaxed text-sm"> "{testimonial.quote}" </blockquote> 
<p className="text-primary-600 font-semibold text-sm"> - {testimonial.family} </p> 
</motion.div> 
))} 
</div> 
</motion.div> 

<motion.div initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{delay: 0.5}} className="text-center" > 
<div className="flex flex-col sm:flex-row gap-4 justify-center"> 
<BookingButton text="Join Our Success Stories" /> 
<motion.a whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} href="https://www.wethebillions.com/quiz" className="btn-secondary" > 
See If We're Right For You 
</motion.a> 
</div> 
</motion.div> 
</div> 
</section> 
);
};

export default ResultsSection;